import { g as d } from "./_commonjsHelpers-OnjxAlhP.js";
const i = () => {
  var r, n;
  const o = (r = d().document) == null ? void 0 : r.body, t = (n = d()) == null ? void 0 : n.window;
  if (o && t)
    return t.innerWidth - o.offsetWidth;
};
export {
  i as g
};
